export default "__VITE_ASSET__35cec01c__"